import actions from './actions';

const toggleMSRP = actions.toggleMSRP;

export { toggleMSRP };
